import { Controller } from '@hotwired/stimulus';

const deactiveCode = 'false';

export default class extends Controller {
  static values = { id: String };

  connect() {
    if (this.isActive) {
      this.fadeIn(this.element, 200);
    }
  }

  /*일정 기간 안보기*/
  deactivate(event) {
    this.setCookie(this.activeCookieName, deactiveCode);
    this.fadeOut(this.element, 200);
  }

  close(event) {
    this.fadeOut(this.element, 200);
  }

  fadeIn(element, time) {
    if (this.running) {
      return;
    }
    this.running = true;

    element.style.opacity = 0;
    element.style.display = 'block';

    let last = +new Date();
    let tick = () => {
      element.style.opacity = +element.style.opacity + (new Date() - last) / time;
      last = +new Date();

      if (+element.style.opacity < 1) {
        (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
      } else {
        this.running = false;
      }
    };

    tick();
  }

  fadeOut(element, time) {
    if (this.running) {
      return;
    }
    this.running = true;

    element.style.opacity = 1;

    let last = +new Date();
    let tick = () => {
      element.style.opacity = +element.style.opacity - (new Date() - last) / time;
      last = +new Date();

      if (+element.style.opacity > 0) {
        (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
      } else {
        this.running = false;
        element.style.display = 'none';
      }
    };

    tick();
  }

  setCookie(name, value) {
    let todayDate = new Date();
    todayDate.setHours(24);
    document.cookie = name + '=' + escape(value) + '; path=/; expires=' + todayDate.toGMTString() + ';';
  }

  getCookie(name) {
    let found = false;
    let start;
    let end;
    let i = 0;

    while (i <= document.cookie.length) {
      start = i;
      end = start + name.length;

      if (document.cookie.substring(start, end) == name) {
        found = true;
        break;
      }
      i++;
    }

    if (found == true) {
      start = end + 1;
      end = document.cookie.indexOf(';', start);
      if (end < start) {
        end = document.cookie.length;
      }
      return document.cookie.substring(start, end);
    }
    return '';
  }

  get activeCookieName() {
    return `popup${this.idValue}`;
  }

  get isActive() {
    return this.getCookie(this.activeCookieName) != deactiveCode;
  }
}
